import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from "@angular/router";

import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'

import { SessionService } from '../providers/session.service';
import { AlertService } from '../providers/alert.service';



@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	constructor(
		private router: Router,
		public session: SessionService,
		private injector: Injector,
		public alerts: AlertService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let token
		token = this.session.getToken();
		// console.log("interceptor???????", token)
		request = request.clone({
			headers: request.headers.set('Authorization', 'Bearer ' + token)
		});
		// console.log('request interceptor', next.handle(request))
		return next.handle(request)
		// .catch((res) => {
		// 	console.log(res);
		// 	if (res.status === 401 || res.status === 403) {
		// 		this.alerts.openAlert('Sessão Expirada!', 'Sua sessão expirou, por favor faça login novamente.');
		// 	}
		// 	return Observable.throw(res);
		// });
	}
}